import { lazy } from 'react'

import { PagesContextDocument, PagesPageHeaderInfoDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import {
  NavigationRoutesFn,
  buildModuleRoute,
  buildNavigation,
} from 'modules/core/lib/react-router'

type Routes = ReturnType<NavigationRoutesFn>
type Navigation = Parameters<NavigationRoutesFn>[0]

const RootPage = lazy(() => import('modules/pages/pages/RootPage'))
const Overview = lazy(() => import('modules/pages/pages/Overview'))
const FoldersPage = lazy(() => import('modules/pages/pages/Folders'))
const Page = lazy(() => import('modules/pages/pages/Page'))

export const pagesRoutes = buildNavigation((navigation) => {
  return [
    buildModuleRoute({
      path: navigation.pages.path,
      element: <RootPage />,
      handle: {
        module: 'pages',
        moduleName: () => i18n.t('sidebar.policies'),
        meta: ({ watchQuery }) => {
          return watchQuery({
            query: PagesContextDocument,
          }).map(({ data }) => {
            const canEditPages = data?.handbookPages._policies.editHandbookPages.can ?? false

            return {
              title: i18n.t('sidebar.policies'),
              subNavigation: [
                {
                  title: i18n.t('pages.tabs.overview'),
                  href: navigation.pages.fullPath(),
                  isVisible: canEditPages,
                  index: true,
                },
                {
                  title: i18n.t('pages.tabs.pages'),
                  href: navigation.pages.list.fullPath(),
                },
              ],
            }
          })
        },
      },

      children: [...allPages(navigation)],
    }),
  ]
})

function allPages(navigation: Navigation): Routes {
  return [
    {
      index: true,
      element: <Overview />,
    },
    {
      path: navigation.pages.list.path,
      element: <FoldersPage />,
    },
    {
      path: navigation.pages.page.path,
      element: <Page />,
      handle: {
        resource: true,
        meta: ({ params: { pageId }, watchQuery }) => {
          return watchQuery({
            query: PagesPageHeaderInfoDocument,
            variables: {
              id: pageId ?? '',
            },
          }).map(({ data }) => {
            const page = data?.handbookPages.page
            return {
              title: page?.title,
              headerComponent: null,
            }
          })
        },
      },
    },
  ]
}
